import React from 'react';
import ReactDOM from 'react-dom';
import { Col, Row } from 'reactstrap';
import { T } from '../../traks';
import "./styles.css"
import { RenderIf } from '../../helpers/RenderIf';

const ConfirmModal = ({
	isShowing,
	hide,
	header = "This is the default header text",
	body = "Are you sure you want to do that thing?",
	onConfirm
}) => {
	const portalContainer = document.getElementById("app_root");
	if (isShowing) {
		document.body.style.overflow = 'hidden';
	}
	return isShowing && (
		ReactDOM.createPortal(
			<React.Fragment>
				<div className="modal-overlay" >
					<div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
						<ConfirmContent
							header={header}
							body={body}
							onConfirm={onConfirm}
							hide={() => hide(false)}
							portal={true}
						/>
					</div>
				</div>
				<div className="modal-backdrop show"></div>
			</React.Fragment >, portalContainer)
	)
}

export const ConfirmContent = ({ header, body, onConfirm, hide, portal = false }) => {
	const className = portal ? "modality shadow sibilus_border sborder_radius_6px" : ""

	

	return (
		<div className={className}>
			<RenderIf condition={portal}>
				<div className="modal-header">
					<button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</RenderIf>
			<Row className="my-3">
				<Col className="mx-5">
					<div className="d-flex flex-column m-4 align-items-center">
						<div className="my-3">
							<h2>{header}</h2>
						</div>
						<div className="my-3">{body}</div>
						<div className="d-flex flex-row mx-3 mt-5">
							<button onClick={onConfirm} className="btn btn_green mx-3"><T>Confirm</T></button>
							<button onClick={hide} className="btn btn_red mx-3"><T>Cancel</T></button>
						</div>
					</div>
				</Col>
			</Row>
		</div>
	)
}
export default ConfirmModal;
